var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kus-home-info primary white--text"},[_c('div',{staticClass:"kus-home-info--content"},[_c('h4',[_vm._v("Bienvenue dans l'application Kushim")]),_c('p',[_vm._v("Comptabilité en ligne collaborative")])])])
}]

export { render, staticRenderFns }